import type { FilterConfigGroupItem } from '../FilterConfigTypes';

export const listMatchingGroupItems: Array<FilterConfigGroupItem> = [
  {
    groupLabel: 'NPI Attributes',
    ordinalPosition: 2,
    tooltip:
      'The NPI Attributes section provides a suite of tools to refine your audience targeting based on specific attributes associated with healthcare professionals. These attributes cover various aspects such as demographics, education, specialization, and location. By utilizing the NPI Attributes section, you can tailor your outreach efforts to target healthcare professionals who match your desired criteria, ensuring your campaigns are highly relevant and effective.',
    filtersInGroup: [
      { name: 'age_range_filter', index: 1 },
      { name: 'years_practiced_range_filter', index: 2 },
      { name: 'state_name_filter', index: 3 },
      { name: 'net_worth_filter', index: 4 },
    ],
    advancedGroup: false,
  },
  {
    groupLabel: 'Patient Attributes',
    ordinalPosition: 3,
    tooltip:
      'The Patient Attributes section provides filters to refine audience targeting based on specific characteristics related to patients. These attributes encompass various factors such as demographics, medical history, and clinical conditions. By utilizing the Patient Attributes section, users can tailor their outreach efforts to target healthcare professionals who treat patients with specific characteristics or conditions.',
    filtersInGroup: [
      { name: 'patient_gender_filter', index: 1 },
      { name: 'patient_age_range_filter', index: 2 },
      { name: 'patient_facility_name_filter', index: 3 },
      { name: 'patient_state_name_filter', index: 4 },
    ],
    advancedGroup: false,
  },
  {
    groupLabel: 'Contextual',
    ordinalPosition: 5,

    filtersInGroup: [
      { name: 'iab_subgroup', index: 1 },
      { name: 'mesh_subgroup', index: 4 },
    ],
    requiredPermissions: ['Moments', 'IBHealth'],
    advancedGroup: false,
  },
];
